<template>
  <div class="w-full mb-10">
    <div class="flex items-center">
      <ebr-h2 :content="$t('tour_detail.included_services.title')" :classes="'text-left ml-3'"/>
    </div>
    <div class="grid grid-cols-1 lg:grid-rows-2 lg:grid-cols-4 gap-5 mt-5">
      <ebr-text-slide
        class="cursor-defaul"
        v-for="service in tour.info.services" :key="service.id"
        :icon="service.icon"
        :title="service.title"
        :description="service.description" />
    </div>
  </div>
</template>

<script>
import SlideTextVue from '../../atoms/slides/SlideText.vue';
import H2Vue from '../../atoms/typography/H2.vue';

export default {
  props: {
    tour: {
      type: Object,
      required: true,
    },
  },
  components: {
    'ebr-text-slide': SlideTextVue,
    'ebr-h2': H2Vue,
  },
};
</script>

<style>

</style>
